import { RouteRecordRaw } from "vue-router"
import { DashboardRouteNameEnum } from "@/shared/enums/routes/dashboard.enum.ts"
import { AppPermissions } from "@/shared/permissions"

const dashboardPermission = {
	any: [
		AppPermissions.CanViewOwnStatistics,
		AppPermissions.CanViewSubordinateStatistics,
		AppPermissions.CanViewScreenOwnerStatistics,
	],
}

export const dashboardRoutes: RouteRecordRaw[] = [
	{
		path: "/",
		redirect: { name: DashboardRouteNameEnum.dashboard },
	},
	{
		path: "/dashboard",
		name: DashboardRouteNameEnum.dashboard,
		component: () => import("@/pages/dashboard/DashboardPage.vue"),
		meta: {
			title: DashboardRouteNameEnum.dashboard,
			layout: "MainLayout",
			authRequired: true,
			permission: dashboardPermission,
		},
	},
];
